<template>
  <div class="login_container">
    <img src="@/assets/blueTee1.jpg" alt />
    <div class="login_box">
      <img src="@/assets/1.png" alt />
      <!-- 登录表单区域 -->
      <el-row class="login_form">
        <el-col :span="24" class="logoBox">
          <div class="lf-box">
            <ul>
              <li>
                <img src="@/assets/logo2.png" alt />
              </li>
              <li>BlueTee后台</li>
              <li>BlueTee</li>
            </ul>
          </div>
        </el-col>

        <el-col :span="18" style="margin-left: 60px">
          <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules">
            <el-row class="loginForm">
              <!-- 用户名 -->
              <el-col :span="24">
                <el-form-item prop="username">
                  <el-input
                    v-model.trim="loginForm.username"
                    prefix-icon="el-icon-user"
                    @keyup.native.enter="login"
                    placeholder="请输入手机号/账号"
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 密码 -->
              <el-col :span="24">
                <el-form-item prop="password">
                  <el-input
                    v-model.trim="loginForm.password"
                    prefix-icon="el-icon-lock"
                    type="password"
                    show-password
                    @keyup.native.enter="login"
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 验证码 -->
              <!--<el-col :span="24" class="Verification">
                <el-form-item prop="code" class="verify">
                  <el-input
                    v-model.trim="loginForm.code"
                    placeholder="请输入验证码"
                    @keyup.native.enter="login"
                  ></el-input>
                  <span class="pic">
                    <img :src="this.picCode" alt @click="variation" />
                  </span>
                </el-form-item>
              </el-col>-->
              <!-- 按钮区域 -->
              <el-col :span="24" class="button-box">
                <el-form-item>
                  <el-button @click="login" v-preventReClick>登 录</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { setSn } from '@/utils/utils'
import { clientId } from '@/utils/clientID'

export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        // code: ''
      },
      loginFormRules: {
        // 验证用户名是否合法
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            min: 11,
            max: 11,
            message: '请输入合法的手机号',
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '长度在 6 到 15 个字符',
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            min: 4,
            max: 4,
            message: '长度在4个字符',
            trigger: 'blur'
          }
        ]
      },
      picCode: ''
    }
  },
  created() {
    // this.getClod()
  },

  methods: {
    async getClod() {
      const sn = new Date().getTime()
      setSn(sn)
      this.picCode = `${this.getaway.user}auth/genVerificationCode?from=${clientId.WEB}&sn=${sn}`
    },
    variation() {
      this.picCode = this.picCode + '&k=' + Math.random()
    },

    login() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (valid) {
          (await this.$store.dispatch('auth/login', this.loginForm)) === true
            ? await this.$router.push('/home')
            : this.variation()
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}

.button-box {
  .el-button {
    width: 100%;
    height: 46px;
    background-color: transparent;
    border-radius: 0;
    color: #d0cdd6;
    border: 1px solid #c4c7ca;
    box-shadow: 0px 0px 40px 4px rgba(234, 234, 234, 0.4) inset;
  }
}

.loginForm .el-col {
  margin: 20px 0;

  .el-input {
    border: none;
  }
}

.loginForm .Verification {
  .el-input {
    width: 100%;
    border: none;
  }
}

.logoBox {
  margin: 40px 0;
  height: 50px;

  .lf-box {
    height: 100%;
    vertical-align: middle;
    font-size: 16px;
    color: #dddedf;

    ul {
      width: 100%;
      height: 100%;
      display: flex;

      li {
        line-height: 50px;

        &:nth-child(1) {
          flex: 1;
        }

        &:nth-child(2) {
          flex: 10;
        }

        &:nth-child(3) {
          flex: 1;
        }
      }
    }

    img {
      height: 50px;
      width: 52px;
    }
  }
}

body {
  height: 100%;
}

.login_container {
  height: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}

.login_box {
  width: 726px;
  height: 560px;
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.2);
  overflow: hidden;
  .el-form {
    overflow: hidden;
    background-color: transparent;
  }

  > img {
    width: 100%;
    height: 100%;
  }
}

.login_form {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: transparent;
}

.btns {
  display: flex;
  justify-content: flex-end;
}

/deep/ .verify {
  position: relative;

  .el-input__inner {
    width: 70%;
  }

  .pic {
    position: absolute;
    top: -3px;
    right: 0;
    width: 120px;
    height: 40px;
    border: 1px solid #dcdfe6;
  }
}

.el-row {
  background-color: transparent;
}

/deep/ .el-form .el-input__inner {
  background-color: transparent;
  border: 1px solid transparent;
  border-bottom: 1px solid #c4c7ca;
  border-radius: 0;
  color: #fff;
}
</style>
